import { Grid, List, ListItem, Paper } from '@material-ui/core';
import {
    useGetVehiclePaveListQuery
} from 'features/vehicles/vehicleSlice';
import { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import PaveItem from './PaveItem';
import { vehiclePaveListStyle } from './style';
import LaunchIcon from '@material-ui/icons/Launch';
import LoadingSpinner from 'components/LoadingSpinner';

const VehiclePaveList = ({ }) => {
    const classes = vehiclePaveListStyle();
    const history = useHistory();
    let { id } = useParams();
    let { data: paveList, error, isLoading: isLoadingPave } = useGetVehiclePaveListQuery(id);

    const [selectedPave, setSelectedPave] = useState(paveList?.[0]);


    return (
        <Grid container spacing={1} className={classes.wrapper}>
            <LoadingSpinner loading={isLoadingPave} />
            <Grid item xs={3} >
                <List disablePadding className={classes.list} >
                    {paveList?.map((p, index) =>
                        <ListItem className={classes.card} selected={selectedPave?.id === p?.id} component={Paper} button item key={index} onClick={() => setSelectedPave(p)}>
                            <PaveItem key={index} item={p} onSelect={() => setSelectedPave(p)} />
                        </ListItem>
                    )}
                </List>
            </Grid>

            <Grid container item xs={9}>
                <Paper className={classes.viewer}>
                    {selectedPave?.paveResultsUrl && <embed src={selectedPave?.paveResultsUrl} style={{ width: '100%', minHeight: '500px' }} />}
                </Paper>
            </Grid>
        </Grid>
    )
}
export default VehiclePaveList;

